// How far through the quiz a screen sits, as after-www counts it: the
// entry's position over the run plus the finishing step past the last
// entry. Pure, so the rule is testable without the bar's markup.

import { QUIZ_QUESTIONS } from "./questions";

export function quizProgressPercent(questionKey: string): number {
  const index = QUIZ_QUESTIONS.findIndex((q) => q.key === questionKey);
  if (index === -1) return 0;
  return Math.min(
    Math.round(((index + 1) / (QUIZ_QUESTIONS.length + 1)) * 100),
    100,
  );
}
